import api from '../utils/api';

// Fetch all grading policies
export const getGradingPolicies = async (headers) => {
  try {
    const response = await api.get('/api/grading/policies', headers);
    console.log("grading policies ", response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching grading policies:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific grading policy by ID
export const getGradingPolicyById = async (id, headers) => {
  try {
    const response = await api.get(`/api/grading/policies/${id}`, headers);
    console.log("grading policy by id", response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching grading policy with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a grading policy by policyName
export const getGradingPolicyByName = async (policyName, headers) => {
  try {
    const response = await api.get(`/api/grading/policies`, { params: { policyName }, ...headers });
    console.log("grading policy by name", response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching grading policy with name ${policyName}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new grading policy
export const createGradingPolicy = async (gradingPolicyData, headers) => {
  try {
    const response = await api.post('/api/grading/policies', gradingPolicyData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating grading policy:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing grading policy
export const updateGradingPolicy = async (id, gradingPolicyData, headers) => {
  try {
    const response = await api.put(`/api/grading/policies/${id}`, gradingPolicyData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating grading policy with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a grading policy
export const deleteGradingPolicy = async (id, headers) => {
  try {
    const response = await api.delete(`/api/grading/policies/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting grading policy with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
